import React, { useState } from "react";
import { ShareNetwork, TwitterLogo, WhatsappLogo, Copy, Check } from "@phosphor-icons/react";

/**
 * Inline share menu for a winning pick.
 * Uses Twitter/X intent + wa.me deeplinks — no SDKs, no PII to 3rd parties.
 */
export default function ShareSlip({ pick, date, testIdPrefix }) {
    const [open, setOpen] = useState(false);
    const [copied, setCopied] = useState(false);

    const url = typeof window !== "undefined" ? `${window.location.origin}/results` : "";
    const odds = Number(pick.odds || 0).toFixed(2);
    const headline = `🏆 ${pick.match} — ${pick.prediction} (${odds}) hit on KickLoom!`;
    const body = `${headline}\nAI pick from ${date} on ${pick.league}. Tail tomorrow's slip → ${url}`;

    const twitter = `https://twitter.com/intent/tweet?text=${encodeURIComponent(body)}`;
    const whatsapp = `https://wa.me/?text=${encodeURIComponent(body)}`;

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(body);
            setCopied(true);
            setTimeout(() => setCopied(false), 1500);
        } catch {
            // Clipboard API unavailable — fail silently; user can use share buttons.
        }
    };

    return (
        <div className="relative inline-block" data-testid={`${testIdPrefix}-share-wrap`}>
            <button
                type="button"
                onClick={() => setOpen((o) => !o)}
                className="inline-flex items-center gap-1.5 px-2.5 py-1 border border-primary/40 text-primary font-mono text-[10px] uppercase tracking-widest hover:bg-primary hover:text-primary-foreground transition-snappy"
                data-testid={`${testIdPrefix}-share-btn`}
                aria-label="Share this winning pick"
            >
                <ShareNetwork size={12} weight="fill" />
                Share win
            </button>
            {open && (
                <div
                    className="absolute right-0 top-full mt-2 z-30 bg-card border border-primary/40 p-2 flex flex-col gap-1 min-w-[180px] shadow-2xl"
                    role="menu"
                    data-testid={`${testIdPrefix}-share-menu`}
                >
                    <a
                        href={twitter}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 px-2 py-1.5 text-xs font-mono uppercase tracking-widest text-zinc-200 hover:bg-primary/10 hover:text-primary"
                        data-testid={`${testIdPrefix}-share-twitter`}
                        onClick={() => setOpen(false)}
                    >
                        <TwitterLogo size={14} weight="fill" /> Twitter / X
                    </a>
                    <a
                        href={whatsapp}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex items-center gap-2 px-2 py-1.5 text-xs font-mono uppercase tracking-widest text-zinc-200 hover:bg-primary/10 hover:text-primary"
                        data-testid={`${testIdPrefix}-share-whatsapp`}
                        onClick={() => setOpen(false)}
                    >
                        <WhatsappLogo size={14} weight="fill" /> WhatsApp
                    </a>
                    <button
                        type="button"
                        onClick={copy}
                        className="flex items-center gap-2 px-2 py-1.5 text-xs font-mono uppercase tracking-widest text-zinc-200 hover:bg-primary/10 hover:text-primary text-left"
                        data-testid={`${testIdPrefix}-share-copy`}
                    >
                        {copied ? <Check size={14} weight="fill" /> : <Copy size={14} />}
                        {copied ? "Copied!" : "Copy text"}
                    </button>
                </div>
            )}
        </div>
    );
}
